import { DialogHandler } from "../../../shared";
import DialogCustom from "../../DesignComponents/DialogCustom";
import FindToolContent from "./components/FindToolContent";

const FindToolMobile = ({ isOpen, close }: DialogHandler) => {
    return (
        <DialogCustom noPadding open={isOpen} close={close}>
            <FindToolContent close={close} />
        </DialogCustom>
    );
};

export default FindToolMobile;
